// import $ from 'jquery';
// import branchBar from './modules/branch-bar';

// Polyfills
// require('./modules/ie-polyfills');

// import carSearch from './modules/car-search';
// import multiSelect from './modules/multiselect'; // replaced with re-multiselect
// import frontPageBannerCarousel from './modules/frontpage-banner-carousel';
// import carCard from './modules/car-card';
// import modals from './modules/modals';
// import forms from './modules/forms';
// import smoothScroll from './modules/smooth-scroll';
// import serviceSearch from './modules/service-search';
// import contactList from './modules/contact-list';
// import contactSingle from './modules/contact-single';
// import './modules/tab-menu';
// import collasible from './modules/collasible.js';
// import financeCalculator from './modules/finance-calculator';
// import copyToClipboard from './modules/copy-to-clipboard';
// import campaignSearch from './modules/campaign-search';
// import campaignCarSearch from './modules/campaign-car-search';
// import styleFallback from './modules/style-fallback';
// import initAdditionalContentButtons from './modules/additional-content';
// import initCustomFileInputs from './modules/custom-file-input';
// import initJobApplicationForm from './modules/job-application-form';
// import initTestDriveForm from './modules/test-drive-form';
// import initArticleList from './modules/article-list';
// import links360 from './modules/links-360';

// These are basically on every page, so we can import them unconditionally
import AjaxForm from './modules/ajax-forms';
import gtmEventPusher from './modules/gtm-event-pusher';
import initSiteSearch from './modules/site-search';

import imageCarousel from './modules/image-carousel';
// carpage has this above the fold, so it's not lazy loaded
import carImageCarousel from './modules/car-image-carousel';

// ReMultiselect initializes in re-multiselect file and it
require('./modules/re-multiselect.js'); // needs to be required here, since car-search.js uses it
require('./modules/car-carousel');
require('./modules/navigation');

// require('./modules/news-carousel');

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // ====================
  // Initialize modules unconditionally
  // ====================

  // Site search
  initSiteSearch();

  // Ajax forms
  AjaxForm.init();

  // GTM event pusher
  gtmEventPusher.init();

  // Flickity image carousel (trucks/paallirakennetuotanto/ -page)
  imageCarousel.init();

  // Swiper image carousel (top of car page)
  carImageCarousel.init();

  // ====================
  // Initialize modules conditionally
  // note: if webpackMode is set to "lazy", it means that JS contain scss imports; conditional styles!
  // ====================

  // Initialize news carousel
  if (document.getElementsByClassName('news-container').length) {
    import(/* webpackChunkName: 'news-carousel', webpackMode: "lazy" */ './modules/news-carousel/news-carousel.js').then(
      ({ default: initNewsCarousel }) => {
        initNewsCarousel();
      },
    );
  }

  // Initialize free text search
  if (document.getElementsByClassName('js-free-text-search').length) {
    import(/* webpackChunkName: 'js-free-text-search', webpackMode: "lazy" */ './modules/free-text-search.js').then(
      ({ default: FreeTextSearch }) => {
        FreeTextSearch.init();
      },
    );
  }

  // Initialize branch bar
  if (document.getElementById('js-branch-bar')) {
    import(/* webpackChunkName: 'branchBar', webpackMode: "lazy" */ './modules/branch-bar.js').then(({ default: branchBar }) => {
      branchBar.init();
    });
  }

  // Initialize front page banner carousel
  const frontPageBannerCarousel = document.getElementById('frontpage-jumbotron');
  if (frontPageBannerCarousel) {
    import(/* webpackChunkName: 'frontPageBannerCarousel' */ './modules/frontpage-banner-carousel.js').then(
      ({ default: frontPageBannerCarousel }) => {
        frontPageBannerCarousel.init();
      },
    );
  }

  // Initialize car card
  const carCard = document.getElementById('car-card');
  if (carCard) {
    import(/* webpackChunkName: 'carCard' */ './modules/car-card.js').then(({ default: carCard }) => {
      carCard.init();
    });
  }

  // Initialize modals
  const modalContainers = document.getElementsByClassName('modal-container');
  if (modalContainers.length) {
    import(/* webpackChunkName: 'modals' */ './modules/modals.js').then(({ default: modals }) => {
      modals.init();
    });
  }

  // Initialize forms if they have special classes
  const specialFormClasses = ['.kayttoauto-form', '.service-reservation-form'];
  const specialForms = document.querySelectorAll(specialFormClasses.join(', '));
  if (specialForms.length) {
    import(/* webpackChunkName: 'forms' */ './modules/forms.js').then(({ default: forms }) => {
      forms.init();
    });
  }

  // Initialize smooth scroll
  // const smoothScrollLinks = document.getElementsByClassName('smooth-scroll');
  // if (smoothScrollLinks.length) {
  //  import(/* webpackChunkName: 'smoothScroll' */ './modules/smooth-scroll.js').then(({ default: smoothScroll }) => {
  //    smoothScroll.init();
  //  });
  // }

  // Initialize outlet's service search
  const outletServiceSearch = document.getElementById('outlet-service-search');
  if (outletServiceSearch) {
    import(/* webpackChunkName: 'serviceSearch' */ './modules/service-search.js').then(({ default: serviceSearch }) => {
      serviceSearch.init();
    });
  }

  // Initialize contact page list
  const contactList = document.getElementById('contact-page-list');
  if (contactList) {
    import(/* webpackChunkName: 'contactList' */ './modules/contact-list.js').then(({ default: contactList }) => {
      contactList.init();
    });
  }

  // Initialize contact page single
  const contactSingle = document.getElementById('contact-page-single');
  if (contactSingle) {
    import(/* webpackChunkName: 'contactSingle' */ './modules/contact-single.js').then(({ default: contactSingle }) => {
      contactSingle.init();
    });
  }

  // Initialize tab menu if tab buttons exist
  if (document.getElementsByClassName('tab-button').length) {
    import(/* webpackChunkName: 'tabMenu' */ './modules/tab-menu.js').then(({ default: tabMenu }) => {});
  }

  if (document.getElementsByClassName('r3multiselect').length) {
    import(/* webpackChunkName: 'r3multiselect', webpackMode: "lazy" */ './modules/multiselect-builder').then(({ init }) => {
      init();
    });
  }
  // Initialize car search
  const carSearch = document.getElementById('car-search');
  const vehicleSearch = document.getElementById('vehicle-search');
  if (vehicleSearch) {
    import(/* webpackChunkName: 'vehicle-search' */ './modules/vehicle-search.js').then(({ default: vehicleSearch }) => {
      let vsInit = setInterval(() => {
        // Gotta wait for multiselects to init
        if (window.r3multiselects) {
          vehicleSearch.init();
          clearInterval(vsInit);
        }
      }, 100);
    });
  } else if (carSearch) {
    import(/* webpackChunkName: 'carSearch' */ './modules/car-search.js').then(({ default: carSearch }) => {
      window.carSearch = carSearch;
      carSearch.init();
      // Disable form submit
      document.getElementById('car-search').addEventListener('submit', function (event) {
        event.preventDefault();
        return;
      });
    });
  }

  const selectFilters = document.querySelector('.js-filter-models');
  if (selectFilters) {
    import('./modules/filter-select').then(fs => fs.default.init());
  }

  // Initialize "collasible". Not a typo, it's a custom component, since 'collapsible' is a reserved classname in Bootstrap
  const collasibleTitles = document.getElementsByClassName('collasible-title');
  if (collasibleTitles.length) {
    import(/* webpackChunkName: 'collasible' */ './modules/collasible.js').then(({ default: collasible }) => {
      collasible.init();
    });
  }

  // Initialize finance calculator
  const financeCalculator = document.getElementById('custom-finance-calculator');
  if (financeCalculator) {
    import(
      /* webpackChunkName: 'custom-finance-calculator', webpackMode: "lazy" */ './modules/finance-calculator/finance-calculator.js'
    ).then(({ default: financeCalculator }) => {
      financeCalculator.init();
    });
  }

  // Initialize copy to clipboard
  const sharingBanners = document.getElementsByClassName('social-sharing-banner');
  if (sharingBanners.length) {
    import(/* webpackChunkName: 'copyToClipboard' */ './modules/copy-to-clipboard.js').then(({ default: copyToClipboard }) => {
      copyToClipboard.init();
    });
  }

  // Initialize campaign search
  const campaignSearchForm = document.getElementById('campaign-search-form');
  if (campaignSearchForm) {
    import(/* webpackChunkName: 'campaignSearch' */ './modules/campaign-search.js').then(({ default: campaignSearch }) => {
      campaignSearch.init();
    });
  }

  // Initialize campaign car search
  const campaignCarSearchForm = document.getElementById('campaign-cars-search-form');
  if (campaignCarSearchForm) {
    import(/* webpackChunkName: 'campaignCarSearch' */ './modules/campaign-car-search.js').then(({ default: campaignCarSearch }) => {
      campaignCarSearch.init();
    });
  }

  // Initialize style fallbacks
  const fallbackContainers = document.getElementsByClassName('fallback-supported-elements-container');
  if (fallbackContainers.length) {
    import(/* webpackChunkName: 'styleFallback' */ './modules/style-fallback.js').then(({ default: styleFallback }) => {
      styleFallback.init();
    });
  }

  // Initialize Flickity image carousel
  const imageCarousels = document.getElementsByClassName('flickity-image-carousel');
  if (imageCarousels.length) {
    import(/* webpackChunkName: 'imageCarousel' */ './modules/image-carousel.js').then(({ default: imageCarousel }) => {
      imageCarousel.init();
    });
  }

  // Initialize additional content buttons
  const buttonContainers = document.getElementsByClassName('additional-content-buttons');
  if (buttonContainers && buttonContainers.length) {
    import(/* webpackChunkName: 'additionalContent' */ './modules/additional-content.js').then(
      ({ default: initAdditionalContentButtons }) => {
        initAdditionalContentButtons();
      },
    );
  }

  // Initialize custom file inputs
  const customFileInputs = document.getElementsByClassName('custom-file-input');
  if (customFileInputs && customFileInputs.length) {
    import(/* webpackChunkName: 'customFileInput' */ './modules/custom-file-input.js').then(({ default: initCustomFileInputs }) => {
      initCustomFileInputs();
    });
  }

  // Initialize job application form
  if (document.getElementById('job-application-form')) {
    import(/* webpackChunkName: 'jobApplicationForm' */ './modules/job-application-form.js').then(({ default: initJobApplicationForm }) => {
      initJobApplicationForm();
    });
  }

  // Initialize test drive form
  if (document.getElementById('test-drive-form')) {
    import(/* webpackChunkName: 'testDriveForm' */ './modules/test-drive-form.js').then(({ default: initTestDriveForm }) => {
      initTestDriveForm();
    });
  }

  // Initialize article list
  // Note: "article list" has some common styles with "single-article" so load this on both cases
  if (document.querySelectorAll('.article-list, .single-article').length) {
    import(/* webpackChunkName: 'articleList', webpackMode: "lazy" */ './modules/article-list/article-list.js').then(
      ({ default: initArticleList }) => {
        initArticleList();
      },
    );
  }

  // Initialize links 360
  if (document.getElementById('dialog-360')) {
    import(/* webpackChunkName: 'links360', webpackMode: "lazy" */ './modules/links-360/links-360.js').then(({ default: links360 }) => {
      links360.init();
    });
  }

  // Legacy stuff, splitted from legacy.js to separate files

  // these might not be needed anymore, but in case they are, they are here

  // showroom page is still live
  if (document.getElementById('showroom')) {
    import(/* webpackChunkName: 'showroom', webpackMode: "lazy" */ './legacy/modules/showroom.js').then(({ default: showroom }) => {
      showroom();
    });
  }

  // Ad-lift-collection, "kampanjat", old version.
  if (document.querySelector('.ad-lift-collection')) {
    import(/* webpackChunkName: 'ad-lift-collection', webpackMode: "lazy" */ './legacy/modules/ad-lift-collection.js').then(
      ({ default: adLiftCollection }) => {
        adLiftCollection();
      },
    );
  }

  // old finance calculator
  if (document.querySelector('#finance-calculator')) {
    import(/* webpackChunkName: 'legacy-finance-calculator', webpackMode: "lazy" */ './legacy/modules/finance-calculator.js').then(
      ({ default: financeCalculator }) => {
        financeCalculator();
      },
    );
  }

  //  #license-search
  if (document.querySelector('#license-search')) {
    import(/* webpackChunkName: 'license-search', webpackMode: "lazy" */ './legacy/modules/license-search.js').then(
      ({ default: licenseSearch }) => {
        licenseSearch();
      },
    );
  }

  // #service-service
  if (document.querySelector('#service-service')) {
    import(/* webpackChunkName: 'legacy-service-search', webpackMode: "lazy" */ './legacy/modules/service-search.js').then(
      ({ default: legacyServiceSearch }) => {
        legacyServiceSearch();
      },
    );
  }

  import(/* webpackChunkName: 'modals' */ './modules/navigation2024.js').then(({ default: navigation }) => {
    navigation.init();
  });

  import(/* webpackChunkName: 'modals' */ './modules/campaign-ribbon.js').then(({ default: campaignRibbon }) => {
    campaignRibbon.init();
    console.log('campaign-ribbon initialized');
  });

  // Service spare part form
  if (document.querySelector('#merkki_varaosa'))
    import(/* webpackChunkName: 'service_sparepart_form' */ './modules/service_sparepart_form.js').then(
      ({ default: ServiceSparepartForm }) => {
        new ServiceSparepartForm();
      },
    );

  // Initialize slider
  const sliderElements = document.querySelectorAll('.basic-slider');
  if (sliderElements.length > 0) {
    import(/* webpackChunkName: 'slider' */ './modules/slider.js').then(({ Slider }) => {
      new Slider(sliderElements);
    });
  }

  // Initialize slider
  const minMaxTabs = document.querySelector('.min-max-tabs');
  if (minMaxTabs !== null) {
    import(/* webpackChunkName: 'minMaxTabBox' */ './modules/min-max-tab-box.js').then(({ MinMaxTabBox }) => {
      new MinMaxTabBox(minMaxTabs);
    });
  }

  if (document.querySelector('.read-more-element')) {
    import(/* webpackChunkName: 'readMoreElement' */ './modules/read-more-element.js').then(({ default: ReadMoreElement }) => {
      new ReadMoreElement();
    });
  }

  // branchBar.init();
  // multiSelect.init(); // replaced with re-multiselect
  // frontPageBannerCarousel.init();
  // carCard.init();
  // modals.init();
  // forms.init();
  // smoothScroll.init();
  // serviceSearch.init();
  // contactList.init();
  // contactSingle.init();
  // collasible.init();
  // financeCalculator.init();
  // copyToClipboard.init();
  // campaignSearch.init();
  // campaignCarSearch.init();
  // styleFallback.init();

  // initAdditionalContentButtons();
  // initCustomFileInputs();
  // initJobApplicationForm();
  // initTestDriveForm();
  // initArticleList();
  // links360.init();
});

// New car search initialization
// If car search element exists, initialize
// if(document.getElementById('car-search')) {

//   carSearch.init();

//   // Disable form submit
//   document.getElementById('car-search').addEventListener('submit', function(event) {
//     event.preventDefault();
//     return;
//   });
// }
